/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/horse_medium'
export default icon
